import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../../common/filterCompany/useSettingParams'
import {
  resetData,
  selectCompareLeft,
  selectCompareRight,
  selectLoading,
  selectTableData,
} from '../../store/slice'

const useCallApi = ({ callApi, displayType, ratiosSelected }) => {
  const dispatch = useDispatch()
  const settingParams = useSettingParams()

  const loading = useSelector(selectLoading(callApi.typePrefix))
  const data = useSelector(selectTableData(callApi.typePrefix))
  const compareLeft = useSelector(selectCompareLeft)
  const compareRight = useSelector(selectCompareRight)
  const locale = useSelector((state) => state.i18n.locale)

  const params = {
    ...settingParams,
    companyType: displayType,
    portfolioId1: compareLeft,
    portfolioId2: compareRight,
    ratiosSelected,
  }

  useEffect(() => {
    if (!settingParams) return

    dispatch(callApi(params))

    return () => dispatch(resetData(callApi.typePrefix))
  }, [compareLeft, compareRight, locale, settingParams, displayType])

  return [loading, data, params]
}

export default useCallApi
